export default "__VITE_ASSET__BSSAzaOh__"